export function parse(url = window.location.search) {
  const obj = {};
  const arr = url.match(new RegExp("[?&][^?&]+=[^?&]+", "g"));
  if (arr) {
    arr.forEach((item) => {
      const pairs = item.substring(1).split("=");
      const key = decodeURIComponent(pairs[0]);
      const val = decodeURIComponent(pairs[1]);
      obj[key] = val;
    });
  }
  return obj;
}
let params = { ...parse() };
export default params;
